import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const DonutChart = ({ data, title }) => {
    const labels = Object.keys(data);
    const values = Object.values(data);
    const { colors, borderColors } = generatePaleColors(labels.length);
    const total = values.reduce((acc, value) => acc + value, 0);

    const percentages = values.map(value => ((value / total) * 100).toFixed(2) + '%');

    const chartData = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: colors,
            borderColor: borderColors,
            borderWidth: 1,
        }],
    };

    const options = {
      cutout: '80%',
      plugins: {
        legend: {
          display: false 
        },
      },
    };

    return (
        <div className='exchange_donut_container'>
            <h3>{title.replaceAll('_', ' ')}</h3>
            <div  className='donut_legend_container'>
                <div className="donut_container" style={{ flex: 1 }}>
                    <Doughnut data={chartData} options={options} width={200} height={200} />
                </div>
                <div className='legends_container'>
                    {labels.map((label, index) => (
                        <div className="legend_container" key={index}>
                            <div className="legend_dot" style={{backgroundColor: colors[index],border: `2px solid ${borderColors[index]}`}}></div>
                            <span className='legend_label'>{label}</span>
                            <span className="pourcentage">{percentages[index]}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DonutChart;

const generatePaleColors = (numColors) => {
    const colors = [];
    const borderColors = [];
    let alpha = 0.2;

    for (let i = 0; i < numColors; i++) {
        const colorIndex = i % baseColors.length;
        if (i >= baseColors.length) {
            alpha += 0.2; // Increase alpha for additional colors
        }

        const color = baseColors[colorIndex].replace('rgb', 'rgba').replace(')', `, ${alpha})`);
        const borderColor = baseColors[colorIndex].replace('rgb', 'rgba').replace(')', ', 1)');

        colors.push(color);
        borderColors.push(borderColor);
    }
    return { colors, borderColors };
};

const baseColors = [
    "rgb(44, 196, 41)",
    "rgb(255, 99, 132)",
    "rgb(95,249,180)",
    "rgb(54, 162, 235)",
    "rgb(255, 224, 86)",
    "rgb(44, 199, 199)",
    "rgb(153, 102, 255)",
    "rgb(249,161,37)",
    "rgb(243,85,249)",
    "rgb(119, 23, 101)",
    "rgb(250,128,114)"
];
